import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, Component, useRef, useState, useEffect, useMemo } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
  Container,
  Row, Col,
  CardBody, Card, CardTitle, CardSubtitle,
  Button, Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, Label, Input,
  Spinner

} from "reactstrap"


import TableComponent from './Components/TableComponent'
import { Link, withRouter } from "react-router-dom"
import IndexBloc from "./Blocs/IndexBloc";
import moment from "moment";

const IndexView = (props) => {
  let indexBloc = useMemo(() => new IndexBloc(), []);
  const activeRef = useRef();
  const inactiveRef = useRef();

  const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()


  const [showExportModal, setShowExportModal] = useState(false);
  const [exportData, setExportData] = useState({
    status: null,
    startDate: null,
    endDate: null,
    source: null
  });
  const [fileUrl, setFileUrl] = useState("");
  const [modal, setModal] = useState(false);


  const [isLoadingCreate, setIsLoadingCreate] = useState(false);

  const handleExportClick = () => {
    console.log(showExportModal);
    console.log("Klik Export!");
    setShowExportModal(true);
    console.log(showExportModal);
  };

  const handleTambahMutasi = () => {
    setIsLoadingCreate(true);
    indexBloc.fetchCreate({});
  }

  const handleCloseModal = () => {
    setShowExportModal(false);
    // Reset form data when closing
    setExportData({
      status: null,
      startDate: null,
      endDate: null,
      source: null
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setExportData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleExport = () => {
    handleCloseModal();
    setModal(!modal);
    indexBloc.fetchExport({
      status: exportData.status,
      start_date: exportData.startDate,
      end_date: exportData.endDate,
      source: exportData.source
    });
  };


  useEffect(() => {
    indexBloc.exportChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            setFileUrl(response.file_url);
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    indexBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          setIsLoadingCreate(false);
          if (result.data.status && result.data.response) {
            const newUuid = result.data.response.employee_transfer_uuid;
            props.history.push('?updatemutasi=1&uuid=' + newUuid);
          }
          break;
        case apiResponse.ERROR:
          setIsLoadingCreate(false);
          break;
        default:
          break;
      }
    });

    return () => {
      console.log("unmount");
      indexBloc.exportChannel?.unsubscribe();
      indexBloc.createChannel?.unsubscribe();
    };
  }, []);



  return (
    <Fragment>
      <Container fluid>
        <Card>
          <CardBody>
            <div className="float-end">
              {
                (accessRole('create')) ?
                  <>
                    <Button color="success" onClick={handleExportClick}>
                      <i className="uil-file-download-alt"></i> Export
                    </Button>

                    {/* <button color="success" onClick={handleExportClick}> <i className="uil-file-download-alt"></i> Export</button> */}
                    {" "}
                    <Button color="primary" onClick={handleTambahMutasi} disabled={isLoadingCreate}>
                      {isLoadingCreate ? <Spinner size="sm" /> : 'Tambah Data Mutasi'}
                    </Button>
                  </>
                  : null
              }
            </div>
            <CardTitle>Daftar Mutasi Pegawai</CardTitle>
            <CardSubtitle className="mb-3">
            </CardSubtitle>
            <hr />
            <TableComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} />
          </CardBody>
        </Card>
      </Container>

      {/* Modal Export */}
      <Modal isOpen={showExportModal} toggle={handleCloseModal}>
        <ModalHeader toggle={handleCloseModal}>Export Data Mutasi</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="status">Status Data</Label>
            <Input
              type="select"
              name="status"
              value={exportData.status}
              onChange={handleInputChange}
            >
              <option value="">Semua Status</option>
              <option value="0">Draft</option>
              <option value="1">Selesai</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label for="startDate">
              Tanggal Periode Mulai
            </Label>
            <Input
              type="date"
              name="startDate"
              value={exportData.startDate}
              onChange={handleInputChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label for="endDate">
              Tanggal PeriodeSelesai
            </Label>
            <Input
              type="date"
              name="endDate"
              value={exportData.endDate}
              onChange={handleInputChange}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="source">Sumber Data</Label>
            <Input
              type="select"
              name="source"
              value={exportData.source}
              onChange={handleInputChange}
            >
              <option value="0">Semua Sumber</option>
              <option value="1">Pansel JPT</option>
              <option value="2">Jabfung</option>
              <option value="3">Mapping Mutasi</option>
              <option value="4">Mutasi Pegawai</option>

            </Input>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button color="success" onClick={handleExport}>
            Export
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Download  */}
      <Modal
        isOpen={modal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={() => {
          setModal(!modal);
        }}
      >
        <div className="modal-content">
          <ModalHeader
            toggle={() => {
              setModal(!modal);
              setFileUrl("");
            }}
          >
            Export
          </ModalHeader>
          <ModalBody>
            {fileUrl == "" ? (
              <div className="text-center">
                <Spinner className="m-1" color="primary" />
                <div>Memproses Data</div>
              </div>
            ) : (
              <>
                <Row className="mb-3">
                  <label className="col-md-4">Jenis File</label>
                  <Col md="8">Excel (xlsx)</Col>
                </Row>
                <Row className="mb-3">
                  <label className="col-md-4">Waktu Generate</label>
                  <Col md="8">
                    {moment(new Date()).format("DD/MM/YYYY HH:mm")}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <label className="col-md-4">Link</label>
                  <Col md="8">
                    <a
                      target={"_blank"}
                      className="btn btn-success"
                      href={fileUrl}
                    >
                      Download <i className="fa fa-download ms-1"></i>
                    </a>
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="secondary"
              onClick={() => {
                setModal(!modal);
                setFileUrl("");
              }}
            >
              Kembali
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </Fragment>
  )
}

export default withRouter(IndexView)